import styled from "styled-components";
import bgDesktop from "../images/services_bg_desktop.jpg";
import bgMobile from "../images/services_bg_mobile.jpg";

const Wrapper = styled.div`
  background: linear-gradient(rgba(15, 44, 89, 0.85), rgba(15, 44, 89, 0.85)), url(${bgDesktop});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  padding: 100px 0 80px;
  overflow: hidden;

  @media (max-width: 1020px) {
    padding: 60px 0;
  }

  @media (max-width: 768px) {
    background: linear-gradient(rgba(15, 44, 89, 0.9), rgba(15, 44, 89, 0.9)), url(${bgMobile});
    background-size: cover;
    background-position: center;
    background-attachment: scroll;
  }

  .container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    justify-content: space-between;
    gap: 60px;

    @media (max-width: 1020px) {
      grid-template-columns: 1fr;
      padding: 0 30px;
      gap: 40px;
    }
    
    @media (max-width: 600px) {
      padding: 0 20px;
    }


    h3 {
      color: var(--secondary-color);
      font-family: 'Playfair Display', serif;
      font-size: 2.5rem;
      margin-bottom: 40px;
      position: relative;
      display: inline-block;
      
      &::after {
        content: '';
        position: absolute;
        width: 60px;
        height: 3px;
        bottom: -10px;
        left: 0;
        background-color: var(--secondary-color);
      }

      @media (max-width: 600px) {
        font-size: 2rem;
      }
      @media (max-width: 1020px) {
        text-align: center;
        display: block;
        &::after {
           left: 50%;
           transform: translateX(-50%);
        }
      }
    }

    .left {
      /* height: 500px; - Let height be auto based on image */
      display: flex;
      justify-content: center;

      @media (max-width: 1020px) {
        display: none;
      }

      .image {
        width: 100%;
        max-width: 500px;
        border-radius: var(--radius);
        filter: drop-shadow(0 15px 30px rgba(0,0,0,0.3));
      }
    }
    .right {
      .list-container {
        color: #f8f9f7;
        display: flex;
        flex-direction: column;
        gap: 30px;

        .item {
          width: 100%;
          display: flex;
          align-items: flex-start;
          gap: 20px;

          .number {
            flex-shrink: 0;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background-color: transparent;
            border: 2px solid var(--secondary-color);
            color: var(--secondary-color);
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            padding: 0;
            line-height: normal; /* Avoid baseline clipping */
            font-size: 1.4rem;
            font-weight: 700;
            font-family: 'Playfair Display', serif;
            transition: var(--transition);
          }
          
          &:hover .number {
            background-color: var(--secondary-color);
            color: var(--primary-color);
          }

          .content {
            h4 {
              color: var(--white);
              font-size: 1.3rem;
              font-weight: 700;
              margin-bottom: 8px;
              font-family: 'Playfair Display', serif;
            }
            p {
              font-size: 1.05rem;
              color: rgba(255, 255, 255, 0.85);
              line-height: 1.7;
              font-family: 'Lato', sans-serif;
            }
          }
        }
      }
    }
  }
`;

export default Wrapper;
